import React, { PureComponent } from 'react'
import MajorList                from '../../../components/MajorList/indexNew'
import { getMajors }            from '../../../api/major'
import PropTypes                from 'prop-types'

class Classify extends PureComponent {

  static propTypes = {
    type: PropTypes.number,
    rightIcon: PropTypes.func,
    onMajorClick: PropTypes.func,
  }

  state = {
    categoryName: '',
    majorMap: {},
    openedId: null,
    classifyList: [],
  }

  componentDidMount() {
    const { match } = this.props
    const param = {
      _s_category_id: match.params.id,
      limit: 999,
    }
    const classifyMap = {}
    const classifyList = []
    let categoryName = ''
    getMajors(param).then(res => {
      res.data.forEach(major => {
        const category = major.category
        const classify = major.classify
        if (classifyMap[classify.id]) {
          classifyMap[classify.id].children.push(major)
        } else {
          classifyMap[classify.id] = classify
          classify.children = [major]
          classifyList.push(classify)
        }
        // 获取category的名称
        if (String(category.id) === match.params.id) {
          categoryName = category.name
        }
      })
      this.setState({
        classifyList,
        categoryName,
      })
    })
  }

  getMajors(classifyId) {
    const { openedId } = this.state
    if (openedId === classifyId) {
      this.setState({
        openedId: null,
      })
    } else {
      this.setState({
        openedId: classifyId,
      })
    }
  }

  handleBack() {
    const { history, match } = this.props
    const urlArray = match.url.split('/')
    urlArray.pop()
    history.replace(urlArray.join('/'))
  }

  render() {
    const { categoryName, classifyList } = this.state
    const { rightIcon, onMajorClick } = this.props
    return <div>
      <div className="classify-banner">
        <div>
          <p>专业一级类目</p>
          <h2>{categoryName}</h2>
        </div>
        <a className="btn-backto-category" onClick={this.handleBack.bind(this)}>
          <span>切换专业方向</span><i/>
        </a>
      </div>
      <div className="classify-title">专业二级类目</div>
      <MajorList classifyList={classifyList} rightIcon={rightIcon} onMajorClick={onMajorClick}/>
    </div>
  }
}

export default Classify



// WEBPACK FOOTER //
// ./src/pages/Major/List/Classify.js